import { Flex, Modal } from "antd";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

import BaseButton from "@/components/BaseButton";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { ROUTES } from "@/constants";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { clearReminderModals } from "@/store/slices/ui";

import { StyledAccentText } from "./Styled";

export interface UncompleteCheckoutsModalProps {
    onCloseModal: () => void;
}

export const UncompletedCheckoutsModal: FC<UncompleteCheckoutsModalProps> = ({
    onCloseModal,
}) => {
    const { role } = useAppSelector((state) => state.user);
    const { activeSchedule } = useAppSelector((state) => state.sv);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleConfirm = () => {
        navigate(
            role === "sv"
                ? `${ROUTES.SVCheckout}/${activeSchedule}`
                : ROUTES.Checkout,
        );
        dispatch(clearReminderModals());
    };

    const handleClose = () => {
        onCloseModal();
    };

    const handleIgnore = () => {
        onCloseModal();
    };

    return (
        <Modal
            open
            title=""
            onCancel={handleClose}
            centered
            footer={[]}
            maskClosable={false}
        >
            <Flex vertical style={{ marginBottom: 16 }} gap={16}>
                <PrimaryText fontSize={20} fontWeight="500" textAlign="center">
                    Завершіть оформлення
                </PrimaryText>

                <SecondaryText>
                    У вашому кошику залишилися незавершені замовлення. Якщо ви
                    вносили зміни в налаштування (коментарі, інформацію про
                    дебіторку, самовивіз тощо), то після очищення кешу ці зміни
                    можуть зникнути. Самі замовлення при цьому залишаться
                    збереженими.
                </SecondaryText>

                <SecondaryText>
                    Будь ласка, за потреби перейдіть на сторінку{" "}
                    <StyledAccentText>Кошик</StyledAccentText>, щоб завершити
                    оформлення.
                </SecondaryText>
            </Flex>

            <Flex vertical gap={8}>
                <BaseButton
                    bgColor="success"
                    type="primary"
                    onClick={handleConfirm}
                >
                    Перейти в Кошик
                </BaseButton>

                <BaseButton type="default" onClick={handleIgnore}>
                    Ігнорувати
                </BaseButton>
            </Flex>
        </Modal>
    );
};
